import {DictCodeEnmu} from "./AppDictEnums"
import { messageInformModeEnum, messageInformPeriodEnum, messageStatusEnum } from "./AppEnums"
/**
 * 分类
 */
export const ModoulTypeList=[
	{
		label: "维保档案",
		value: 'archives'
	},
	{
		label: "TCO维保成本核算单",
		value: 'calculate'
	},
	{
		label: "TCO服务核算报价表",
		value: 'quotation'
	},
	{
		label: "打印模板",
		value: 'printSetup'
	},
	{
		label: "故障报修记录",
		value: 'repairRecord'
	},
	{
		label: "派工记录",
		value: 'sendRecord'
	},
	{
		label: "TCO用户成本分析表",
		value: 'userCost'
	}
]


//报价单状态
export const QuotationStatusDs = [
	{
		label: "草拟",
		value: DictCodeEnmu.QUOTATION_DRAFT
	},
	{
		label: "已开单",
		value: DictCodeEnmu.QUOTATION_INIT
	},
	{
		label: "已完结",
		value: DictCodeEnmu.QUOTATION_FINISH
	}
]

//故障报修单状态
export const breakrepairStatusDs = [
	
	{
		label: "已开单",
		value: DictCodeEnmu.REPAIR_INIT
	},
	{
		label: "已转接",
		value: DictCodeEnmu.REPAIR_TRANSFERED
	}
]

export const faultTypeNameStatusDs = [
	
	{
		label: "收费",
		value: DictCodeEnmu.SHOUFEI_shoufei
	 },
	 {
		label: "三包",
		value: DictCodeEnmu.SANBAO_sanbao
	 },
	 {
		label: "云豪大包",
		value: DictCodeEnmu.YUNHAODABAO_yunhaodabao
	 },

]



//车辆品牌类型
export const vehicleBrandTypeList=[
	{
		label: "进口",
		value: '进口'
	},
	{
		label: "国产",
		value: '国产'
	},
]

// //消息提醒次数
// export enum messageInformPeriodEnum {
//     'informPeriod.one'='一次',
// 	'informPeriod.more'='多次 '
// }

// //消息提醒类型
// export enum messageInformModeEnum {
//     'informMode.sms'='短信',
// 	'informMode.officialAccount'='公众号',
// 	'informMode.instation'='站内'
// }

//消息提醒次数
export const messageInformPeriodDs = [
	{
		label: "一次",
		value: messageInformPeriodEnum.INFORMPERIOD_ONE
	 },
	 {
		label: "多次",
		value: messageInformPeriodEnum.INFORMPERIOD_MORE
	 },
]

//消息提醒类型
export const messageInformModeDs = [
	{
		label: "短信",
		value: messageInformModeEnum.INFORMMODE_SMS
	 },
	 {
		label: "公众号",
		value: messageInformModeEnum.INFORMMODE_OFFICIALACCOUNT
	 },
	 {
		label: "站内",
		value: messageInformModeEnum.INFORMMODE_INSTATION
	 },
]

//消息提醒类型
export const messageStatusDs = [
	{
		label: "未读",
		value: messageStatusEnum.MESSAGE_INIT
	 },
	 {
		label: "已读",
		value: messageStatusEnum.MESSAGE_READ
	 },
	 {
		label: "完成",
		value: messageStatusEnum.MESSAGE_END
	 },
]